import { state as annotations } from '../client-schema/annotations/state';
import {
  defaults as commentsDefaults,
  state as comments,
} from '../client-schema/Comment.state';
import {
  defaults as transfersDefaults,
  state as transfers,
} from '../client-schema/transfers/state';
import { state as assets } from './features/assets/state';
import { state as billing } from './features/billing/state/state';
import { getTemplateKey, state as templates } from './features/templates/state';

export { getTemplateKey };

/** globally exported reactive state */
export const state = {
  annotations,
  assets,
  billing,
  comments,
  templates,
  transfers,
};

/** globally exported default values */
export const defaults = {
  comments: commentsDefaults,
  transfers: transfersDefaults,
};
